import { CheckCircleOutlined, EditOutlined, StopOutlined } from "@ant-design/icons";
import { PageHeader, Checkbox, message, Popconfirm, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItem, ButtonItem, SegmentedItem } from "../../../Components/Items";

class TiposDeProveedores extends Component {
  state = {
    todasTiposDeProveedores: [],
    loading: false,
    valor: 1,
  }
  componentDidMount() {
    this.consultarTiposDeProveedores(this.state.valor);
  }

  consultarTiposDeProveedores(valor) {
    this.setState({loading: true})
    axios
    .post(
      "tiposdeproveedores/selectTodosTiposDeProveedores",
      { empresaId: this.props.empresaId, valor: valor },
      {
        headers: this.props.headersToken,
      }
    )
    .then((res) => {
      this.setState({loading: false})
      if (res.data.status === 404) {
        this.setState({ todasTiposDeProveedores: [] });
      } else {
        this.setState({
          todasTiposDeProveedores: res.data.map((value) => {
            return {
              ...value,
              accion: { _id: value._id, estado: value.estado },
            };
          }),
        });
      }
    });
  }
  agregarTipoDeProveedor(){
    this.props.history.push('/panel/agregarTipoDeProveedor')
  }
  editarTipoDeProveedor(id){
    this.props.history.push('/panel/editarTipoDeProveedor', {id})
  }
  deshabilitarTipoDeProveedor(value) {
    axios
      .post(
        "tiposdeproveedores/deshabilitarTipoDeProveedor",
        { tipoDeProveedorId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de Proveedor deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        this.consultarTiposDeProveedores(this.state.valor);
      });
  }
  habilitarTipoDeProveedor(value) {
    axios
      .post(
        "tiposdeproveedores/habilitarTipoDeProveedor",
        { tipoDeProveedorId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Tipo de Proveedor habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        this.consultarTiposDeProveedores(this.state.valor);
      });
  }
  render() {
    const columns = [
      {
        title: "Nombre",
        dataIndex: "nombre",
        key: "nombre",
        sorter: (a, b) => {
          if (a.nombre < b.nombre) {
            return -1;
          }
          if (a.nombre > b.nombre) {
            return 1;
          }
          return 0;
        },
        buscar: "nombre",
        ellipsis: true,
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: (a, b) => {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        },
        buscar: "descripcion",
        ellipsis: true,
      },
      {
        title: "Generar Cuentas en Automatico",
        dataIndex: "generarCuentasAutomatico",
        key: "generarCuentasAutomatico",
        render: (value) => <Checkbox checked={value} />,
        align: "center",
        ellipsis: true,
      },
      {
        title: "Tipo de Poliza Diario",
        dataIndex: "tipoDePolizaDiario",
        key: "tipoDePolizaDiario",
        render: (value) => value.nombre+' - '+value.descripcion,
        ellipsis: true,
      },
      {
        title: "Tipo de Poliza Egreso",
        dataIndex: "tipoDePolizaEgreso",
        key: "tipoDePolizaEgreso",
        render: (value) => value.nombre+' - '+value.descripcion,
        ellipsis: true,
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          if (this.props.permisoEditarTipoDeProveedor) {
            buttons.push(
              <Tooltip title="Editar Tipo de Proveedor" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarTipoDeProveedor(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          if (this.props.permisoDeshabilitarTipoDeProveedor) {
            if (value.estado === 1) {
              buttons.push(
                <Popconfirm
                  key={`deshabilitar-${index}`}
                  title="Seguro que quieres deshabilitar este tipo de proveedor"
                  onConfirm={() => this.deshabilitarTipoDeProveedor(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      lima
                      icon={<CheckCircleOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            } else {
              buttons.push(
                <Popconfirm
                  key={`habilitar-${index}`}
                  title="Seguro que quieres habilitar este tipo de proveedor"
                  onConfirm={() => this.habilitarTipoDeProveedor(value._id)}
                  okText="Si"
                  cancelText="No"
                >
                  <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                    <ButtonItem
                      type="default"
                      size="small"
                      rojo
                      icon={<StopOutlined />}
                    >
                    </ButtonItem>
                  </Tooltip>
                </Popconfirm>
              );
            }
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title="Tipos De Proveedores"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <>
            {window.innerWidth > 1000 &&
             <SegmentedItem
                options={[{label: 'Activo', value: 1}, {label: 'Deshabilitado', value: 2}, {label: 'Todos', value: 3}]}
                onChange={(value) => {
                  this.consultarTiposDeProveedores(value)
                  this.setState({ valor: value })
                }}
                value={this.state.valor}
              />
          }
            {this.props.permisoAgregarTipoDeProveedor &&
            <ButtonItem
              type="primary"
              key="agregarTipoDeProveedor"
              olivo
              onClick={this.agregarTipoDeProveedor.bind(this)}
              className="botonAgregar"
            >
              Agregar Tipo De Proveedor
            </ButtonItem>}
            </>
          }
        />
        <TableItem
          loading={this.state.loading}
          size="small"
          dataSource={this.state.todasTiposDeProveedores}
          columns={columns}
          onRow={(record) => ({
            onDoubleClick: () => this.editarTipoDeProveedor(record._id),
          })}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    permisoAgregarTipoDeProveedor: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cd7b8f30e81b54183cf94")?.activado,
    permisoEditarTipoDeProveedor: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615cd7e4f30e81b54183cf95")?.activado,
    permisoDeshabilitarTipoDeProveedor: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ce4e8f30e81b54183cfb4")?.activado,
  };
};

export default connect(mapStateToProps)(TiposDeProveedores);